import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button, Form, Checkbox, List, Radio, Modal, SpinLoading, Space, Input, CascadePicker } from 'antd-mobile';
import { Toast } from 'antd-mobile';
import 'moment/locale/ru';
import { createUseStyles } from 'react-jss'

import { POST, errorCatch, GET, useAuth, JSXMap, ModelMobile } from 'fennec-ui'
import Icofont from 'react-icofont';
import { Action, ActionPickerItem } from 'fennec-ui';
import Collection from '../../../common/Collection';
import uuid from 'react-uuid';
import "./index.less"
import { Agreement } from '../../../common/Agreement';
import SearchUser from '../SearchUser';
import Nl2Br from '../../../common/Nl2br';

import useSound from 'use-sound';
import bubbleSfx from '../../../sfx-shtrih-kod.mp3';
import { Dialog } from '../../../common/Dialog';
import QR from '../../../common/QR';

import parse from "html-react-parser";
import dayjs from 'dayjs'
import locale from 'antd/es/date-picker/locale/ru_RU';
import 'dayjs/locale/ru'

var isBetween = require('dayjs/plugin/isBetween')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.locale('ru');

var _ = require('lodash');


const useStyles = createUseStyles({
    promoButton: {
        width: "125px",
        fontSize: "14px",
        height: "40px",
        '&.am-button::before': {
            border: "none!important"
        }
    },
    selectPeople: {
        paddingBottom: "5px",
        width: "100%",
        '& .ant-input-prefix': {
            marginRight: "11px"
        },
        '& .ant-input-affix-wrapper': {
            padding: "4px 0px"
        },
        '& .am-list .am-list-body::before': {
            backgroundColor: "transparent"
        },
        '& .am-list .am-list-body::after': {
            backgroundColor: "transparent"
        }
    },
    listMeta: {
        '& .ant-list-item-meta-title': {
            marginBottom: "0"
        },
    },
    itemsListUsluga: {
        '& .ant-list .ant-list-item': {
            // borderBottom: "1px solid #e1e1e1",
            // borderTop: "1px solid #e1e1e1",
            alignItems: "flex-start"
        },
    },
    itemsOrderUsluga: {
        '& .ant-list-item': {
            alignItems: "flex-start",
            border: "none"
        },
    },
    promo: {
        '& .ant-input-affix-wrapper': {
            paddingLeft: "0px",
        },
        '& .adm-list-item-content': {
            borderTop: "none"
        },
        '&': {
            borderBottom: "1px solid darkblue",
            // width: "200px",
        },
        '&:hover': {
            borderBottom: "2px solid darkblue",
        },
    },
    appendButton: {
        '&.am-list-item': {
            // width: "100%",
            width: "190px",
            // backgroundColor: "#d9d9d9",
            boxShadow: "0px 1px 3px 0px rgba(141,141,141,0.74)",
            fontWeight: 500,
            textAlign: "center",
            backgroundColor: "#f1f1f1",
            borderRadius: "5px",
            padding: "0 5px"
        },
        '&.am-list-item .am-list-line-multiple': {
            padding: "5px 13px 5px 5px"
        },
        '&.am-list-item .am-list-line-multiple .am-list-content': {
            paddingTop: "2px",
        }
        // '&.ant-btn:hover': {
        //     color: "#000",
        //     // background: #fff;
        //     boxShadow: "0px 2px 4px 0px rgba(141,141,141,0.74)",
        //     borderColor: "#d9d9d9",
        // },
        // '&.ant-btn:focus': {
        //     color: "#000",
        //     // background: #fff;
        //     boxShadow: "0px 2px 4px 0px rgba(141,141,141,0.74)",
        //     borderColor: "#d9d9d9",
        // }
    },
    peopleInput: {
        '&.am-list-item.am-input-item': {
            height: "25px",
            minHeight: "25px",
            paddingLeft: "0px"
        },
        '&.am-list-item .am-input-label': {
            fontSize: "14px",
            width: "auto",
        },
        '&.am-list-item .am-input-control input': {
            fontSize: "14px",
            fontStyle: "italic",
        },
        '&.am-list-item .am-list-line': {
            paddingRight: "0px"
        }
    },
    listItem: {
        '& .adm-list-item-content': {
            borderTop: "none"
        },
        '&.am-list-item': {
            paddingLeft: "5px",
        },
        '&.am-list-item .am-list-line': {
            paddingRight: "5px"
        }
    },
    listRadioItem: {
        '&.am-list-item .am-list-line .am-list-content': {
            fontSize: "14px"
        },
        '&.am-list-item': {
            paddingLeft: "5px"
        },
        '&.am-list-item .am-list-line': {
            paddingRight: "5px"
        }
    },
    categoryPicker: {
        '& .am-picker-popup-title': {
            fontSize: "13px"
        },
        '& .am-picker-col-indicator': {
            // height: "55px"
        },
        '& .am-picker-col-content': {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            alignContent: "center",
        },
        '& .am-picker-col-item': {
            fontSize: "13px",
            // height: "35px",
            lineHeight: "14px",
            whiteSpace: "break-spaces",

            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
        },
        '& .am-picker-col-item-selected': {
            fontSize: "13px",
            fontWeight: "500"
        }
    },
    categoryPickerListItem: {
        // '&.am-list-item': {
        //     paddingLeft: "0px",
        //     minHeight: "32px"
        // },
        '&.am-list-item .am-list-line .am-list-arrow-horizontal': {
            visibility: "hidden"
        },
        // '&.am-list-item .am-list-line .am-list-content': {
        //     fontSize: "14px",
        //     paddingTop: "3px",
        //     paddingBottom: "3px",
        // },

        '& .am-list-line': {
            display: "block",
        },
        '&.am-list-item .am-list-line .am-list-content': {
            fontSize: "14px",
            paddingBottom: "0px",
        },
        '&.am-list-item .am-list-line .am-list-arrow': {
            position: "absolute",
            right: "0",
            top: "8px",
        },
        // '&.am-list-item .am-list-line .am-list-extra': {
        //     textAlign: "left",
        //     paddingTop: "0px",
        //     paddingBottom: "0px"
        // },
        '&.am-list-item': {
            paddingLeft: "0px"
        },
        '&.am-list-item .am-list-line': {
            paddingRight: "0px"
        },
        '&.am-list-item .am-list-line::after': {
            backgroundColor: "transparent!important"
        },
        '&.am-list-item .am-list-line .am-list-extra': {
            fontSize: "13px",
            textAlign: "left",
            paddingTop: "0px",
            paddingBottom: "0px",
            whiteSpace: "break-spaces",
            // whiteSpace: "initial"
        }
    },
    // checkbox: {
    //     '& .am-checkbox .am-checkbox-inner': {
    //         right: "4px"
    //     }
    // }
})

const Header = ({ icon, title, style }) => {
    return (<span>
        <Icofont icon={icon} style={style} />
        <span>{title}</span>
    </span>);
};
const SingleHeader = ({ title }) => {
    return (<Header icon="user-alt-3" title={(title !== undefined) ? title : "Одиночный"} style={{ color: "cadetblue", fontSize: "13px", paddingRight: "4px" }} />);
};
const CoupleHeader = ({ title }) => {
    return (<Header icon="users-alt-4" title={(title !== undefined) ? title : "Парный"} style={{ color: "purple", fontSize: "13px", paddingRight: "4px" }} />);
};
const FemaleHeader = ({ title }) => {
    return (<Header icon="businesswoman" title={(title !== undefined) ? title : "Женский"} style={{ color: "red", fontSize: "16px", paddingRight: "4px" }} />);
};
const MaleHeader = ({ title }) => {
    return (<Header icon="businessman" title={(title !== undefined) ? title : "Мужской"} style={{ color: "blue", fontSize: "16px", paddingRight: "4px" }} />);
};
const SelectCategory = (props) => {
    const { item, title, value, onChange } = props;
    const [selection, setSelection] = useState();
    const [visible, setVisible] = useState(false);
    const optionsFunc = (item) => {
        let dance = {};
        if (item) {
            item?.uslugiKlientuKategoriiUslugaKlienta?.forEach(e => {
                if (e.dostupnaRegistratsiya) {
                    dance[e.kategoriya.tantsevalnayaDistsiplinaID] = {
                        value: e.kategoriya.tantsevalnayaDistsiplinaID,
                        label: e.kategoriya.tantsevalnayaDistsiplina.nazvanie,
                        children: _.unionBy(
                            (dance[e.kategoriya.tantsevalnayaDistsiplinaID] && dance[e.kategoriya.tantsevalnayaDistsiplinaID].children) ? dance[e.kategoriya.tantsevalnayaDistsiplinaID].children : [],
                            [{
                                kategoriyaID: e.kategoriya.ID,
                                object: e,
                                ID: e.kategoriya.kategoriyaUchastnikovID,
                                value: e.kategoriya.kategoriyaUchastnikovID,
                                label: e.kategoriya.kategoriyaUchastnikov.nazvanie,
                            }],
                            'ID'),
                    }
                }
            });
        }
        return Object.values(dance);
    };
    useEffect(() => {
        if (value) {
            let a = optionsFunc(item);
            let o = [];
            for (let i = 0; i < a.length; i++) {
                const first = a[i];
                for (let j = 0; j < first.children.length; j++) {
                    const second = first.children[j];
                    if (second && value && value.kategoriya && second.kategoriyaID === value.kategoriya.kategoriyaID) {
                        o.push(first);
                        o.push(second);
                    }
                }
            }
            setSelection((o.length === 2) ? o : undefined);
        }
    }, [item, value])
    return (<div className='category-picker'>
        <CascadePicker
            style={{
                '--title-font-size': '13px',
                '--header-button-font-size': '13px',
                '--item-font-size': '13px',
                "--padding-left": "0px",
                "--padding-right": "0px"
            }}
            confirmText={'Выбрать'}
            cancelText={'Отмена'}
            options={optionsFunc(item)}
            visible={visible}
            onClose={() => {
                setVisible(false)
            }}
            onConfirm={e => {
                let d = optionsFunc(item);
                let one = d.find(f => f.value === e[0]);
                let obj = one.children.find(f => f.value === e[1]);
                if (onChange) {
                    onChange(_.get(obj, "object"));
                }
                setSelection([one, obj]);
            }}
            title={title}
            value={selection}
        />
        <List.Item
            arrow={false}
            // extra={(selection) ? selection.map(o => o.label).join(' / ') : <span style={{ color: "red" }}>Укажите категорию!</span>}
            onClick={() => setVisible(true)}>
            {title} - <span style={{ fontSize: "13px", color: "#888" }}>{(selection) ? selection.map(o => o.label).join(' / ') : <span style={{ color: "red" }}>Укажите категорию!</span>}</span>
        </List.Item>
    </div>);
};
const SelectPeople = (props) => {
    const classes = useStyles();
    const user = useSelector(state => state.home.user);
    const auth = useAuth();
    const { item, data, gender, prefix, value, onChange, onChangeSilent } = props;
    const displayText = (object) => {
        if (object === undefined) {
            return "Укажите участника!";
        }
        if (object) {
            if (object.polzovatelStrokoi) {
                return object.polzovatelStrokoi;
            }
            if (object.polzovatel) {
                return object.polzovatel.firstname + " " + object.polzovatel.lastname;
            }
            return "Укажите участника!";
        }
        return <></>;
    };
    const triggerFunc = React.useMemo(() => (click) => (
        <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "baseline" }}>
            <div style={{ flex: "0" }}>{prefix("")}</div>
            <div style={{ flex: "1" }}>
                {/* <Input
                    style={{
                        '--color': (value === undefined) ? "red" : "black",
                        '--font-size': "13px",
                        alignItems: "flex-end"
                    }}
                    onClick={click}
                    value={displayText(value)}
                    editable={"false"}
                /> */}
                <div
                    style={{
                        color: (value === undefined) ? "red" : "black",
                        fontSize: "13px",
                        alignItems: "flex-end"
                    }}
                    onClick={click}
                >{displayText(value)}</div>
            </div>
        </div>
    ), [value]);
    const actionFunc = React.useMemo(() => (values, unlock, close) => {
        // otherPolzovatel
        let o = {
            // ...values, 
            polzovatelStrokoi: values.polzovatelStrokoi,
            polzovatel: (values.otherPolzovatelQR) ? values.otherPolzovatelQR : (values.otherPolzovatel) ? values.otherPolzovatel : values.polzovatel,
            polzovatelID: (values.otherPolzovatelQR) ? values.otherPolzovatelQR : (values.otherPolzovatel) ? values.otherPolzovatel.ID : (values.polzovatel) ? values.polzovatel.ID : undefined,
        }
        onChange(o);
        close();
    }, [onChange])
    const setCategoryFunc = React.useMemo(() => (okazannieUslugiPolzovatelyamUchastikItem) => {
        POST(auth, "/api/zakaz/tovar/okazannieuslugipolzovatelyam/setkategory", okazannieUslugiPolzovatelyamUchastikItem,
            ({ data }) => {
                let o = {
                    ...value, okazannieUslugiPolzovatelyamUchastik: value.okazannieUslugiPolzovatelyamUchastik.map(e => {
                        if (e.ID === data.ID) {
                            return data;
                        }
                        return e;
                    })
                }
                onChangeSilent(o);
            }, errorCatch);
    }, [onChange])
    const setPartnerFunc = React.useMemo(() => (okazannieUslugiPolzovatelyamUchastikItem) => {
        POST(auth, "/api/zakaz/tovar/okazannieuslugipolzovatelyam/setpartner", okazannieUslugiPolzovatelyamUchastikItem,
            ({ data }) => {
                let o = {
                    ...value, okazannieUslugiPolzovatelyamUchastik: value.okazannieUslugiPolzovatelyamUchastik.map(e => {
                        if (e.ID === data.ID) {
                            return data;
                        }
                        return e;
                    })
                }
                // onChange(o)
                onChangeSilent(o);
            }, errorCatch);
    }, [onChange])
    const modalFunc = React.useMemo(() => ({ title: "Указать участника", width: "500px" }));
    const filteredValue = (value && value.okazannieUslugiPolzovatelyamUchastik) ? value.okazannieUslugiPolzovatelyamUchastik.filter(i => i.uslugaKlientu.yacheikaUsluga.prilozhenieID) : undefined;
    return (<div className={classes.selectPeople}>
        <div>
            <Action
                auth={auth}
                mode="func"
                titles={{ header: <span>{prefix("")}Выберите участника</span> }}
                modal={modalFunc}
                object={value}
                okText="Выбрать"
                gender={gender}
                user={user}
                item={item}
                data={data}
                form={SelectUserForm}
                action={actionFunc}
                trigger={triggerFunc}
            />
        </div>
        {!!value && <Services
            data={data}
            value={filteredValue}
            onChangeCategory={(value, okazannieUslugiPolzovatelyamUchastikItem) => {
                let o = { ...okazannieUslugiPolzovatelyamUchastikItem, kategoriyaID: value.ID };
                setCategoryFunc(o)
            }}
            onChangePartner={(value, okazannieUslugiPolzovatelyamUchastikItem) => {
                let o = { ...okazannieUslugiPolzovatelyamUchastikItem, partnerID: value.ID };
                setPartnerFunc(o)
            }} />}
    </div>);
};
const SelectPartner = (props) => {
    const auth = useAuth()
    const { item, value, onChange, data } = props;
    const user = useSelector(state => state.home.user);
    const modalFunc = React.useMemo(() => ({ title: "Указать " + ((value?.tipTDID === 1) ? "ассистента" : "партнера"), width: "500px" }));

    const display = (object) => {
        if (!object) {
            return <span>Укажите {(value?.tipTDID === 1) ? "ассистента" : "партнера"}!</span>;
        }
        if (object) {
            return <span>{object.firstname + " " + object.lastname}</span>;
        }
        return <></>;
    };
    const triggerFunc = React.useMemo(() => (click) => (<div style={{ cursor: "pointer", fontStyle: "italic", color: (!value?.partner) ? "red" : "grey" }} onClick={click}>
        {display(value?.partner)}
    </div>), [value?.partner]);

    const actionFunc = React.useMemo(() => (values, unlock, close) => {
        let o = (values.otherPolzovatelQR) ? values.otherPolzovatelQR : (values.otherPolzovatel) ? values.otherPolzovatel : values.polzovatel;
        onChange(o);
        close();
    }, [onChange])

    // const finduserAction = React.useCallback((values, unlock, close) => {
    //     POST(auth, "/api/find/finduserfilter", { ...values },
    //         ({ data }) => {
    //             close(data);
    //         },
    //         (err) => errorCatch(err, unlock));
    // }, [auth])

    // const steps = React.useMemo(() => [
    //     {
    //         key: "search",
    //         name: "Шаг 1",
    //         action: finduserAction,
    //         form: ModelMobile,
    //         meta: [
    //             {
    //                 label: "Email",
    //                 name: "Email",
    //                 type: "string",
    //                 display: (v) => v,
    //                 validators: {
    //                     required: true,
    //                     min: null,
    //                     max: null,
    //                     pattern: null
    //                 },
    //             },
    //             {
    //                 label: "Фамилия",
    //                 name: "Lastname",
    //                 type: "string",
    //                 display: (v) => v,
    //                 validators: {
    //                     required: true,
    //                     min: null,
    //                     max: null,
    //                     pattern: null
    //                 },
    //             },
    //             {
    //                 label: "Имя",
    //                 name: "Firstname",
    //                 type: "string",
    //                 display: (v) => v,
    //                 validators: {
    //                     required: true,
    //                     min: null,
    //                     max: null,
    //                     pattern: null
    //                 },
    //             },
    //         ],
    //     },
    //     {
    //         key: "select",
    //         name: "Шаг 2",
    //         noAntForm: true,
    //         form: (props) => {
    //             return (
    //                 <div style={{ padding: "0px 10px" }}>
    //                     <div>Подтвердите выбор пользователя:</div>
    //                     <div>ФИО: <span style={{ color: "#000" }}>{(props.data) ? props.data.search.firstname + " " + props.data.search.lastname : ""}</span></div>
    //                     <div>Email: <span style={{ color: "#000" }}>{(props.data) ? props.data.search.email : ""}</span></div>
    //                 </div>
    //             )
    //         },
    //     }
    // ], [auth, finduserAction])

    return (<div style={{ display: "flex", gap: "5px" }}>
        <div style={{ fontStyle: "italic" }}> - {(value?.tipTDID === 1) ? "ассистент" : "партнер"} - </div>
        <div>
            <Action
                auth={auth}
                mode="func"
                trigger={triggerFunc}
                action={actionFunc}
                // steps={steps}
                titles={{ header: "Выбор " + ((value?.tipTDID === 1) ? "ассистента" : "партнера") }}
                modal={{
                    minWidth: "250px",
                    title: "Выбрать " + ((value?.tipTDID === 1) ? "ассистента" : "партнера"),
                }}
                object={value}
                okText="Выбрать"
                user={user}
                item={item}
                data={data}
                form={SelectPartnerForm}
            />
        </div>
    </div>);
};
const Services = (props) => {
    const auth = useAuth();
    const { data, value, onChangeCategory, onChangePartner } = props;
    const onCategoryChange = (value, okazannieUslugiPolzovatelyamUchastikItem) => {
        onChangeCategory(value, okazannieUslugiPolzovatelyamUchastikItem);
    };
    const onPartnerChange = (value, okazannieUslugiPolzovatelyamUchastikItem) => {
        onChangePartner(value, okazannieUslugiPolzovatelyamUchastikItem);
    };
    const find = (data, i) => {
        let o = (data) ? data.find(e => e.ID === i.uslugaKlientuID) : undefined;
        return o;
    };
    return (<React.Fragment>
        {(!!value && value.length > 0) && <List style={{
            '--font-size': "13px",
            '--extra-max-width': "85%",
            '--padding-left': "0px"
        }}>
            {value.map((i, idx) => {
                return (<div key={idx}>
                    <SelectCategory
                        key={idx}
                        title={i.uslugaKlientu.yacheikaUsluga.nazvanie}
                        auth={auth}
                        item={find(data, i)}
                        value={i}
                        onChange={(v) => onCategoryChange(v, i)}
                    />
                    {(i?.tipTDID === 1 || i?.tipTDID === 2) && <div>
                        <SelectPartner
                            auth={auth}
                            item={find(data, i)}
                            value={i}
                            data={data}
                            onChange={(v) => onPartnerChange(v, i)}
                        />
                    </div>}
                </div>)
            })}
        </List>}
    </React.Fragment>);
};
const Male = (props) => {
    const auth = useAuth();
    const { item, index, value, onChange, onChangeSilent, usluga } = props;
    const data = (usluga && usluga.uslugiKlientuUslugaNaMeropriyatii) ? usluga.uslugiKlientuUslugaNaMeropriyatii : undefined; //usluga.uslugiKlientuUslugaNaMeropriyatii.filter(i => i.yacheikaUsluga.prilozhenieID) : undefined;
    const gender = 1;
    const setMergedObject = (obj) => {
        onChange({
            genderID: gender,
            polzovatelStrokoi: obj.polzovatelStrokoi,
            polzovatelID: _.get(obj, "polzovatel.ID"),
            tovarVZakazeID: item.ID
        });
    };
    return (<div style={{ display: "flex", justifyContent: "flex-start" }}>
        <SelectPeople
            uuid={uuid()}
            auth={auth}
            gender={gender}
            prefix={(title) => <MaleHeader title={title} />}
            item={item}
            index={index}
            data={data}
            value={value}
            onChangeSilent={onChangeSilent}
            onChange={(e) => setMergedObject(e)} />
    </div>);
};
const Female = (props) => {
    const auth = useAuth();
    const { item, index, value, onChange, onChangeSilent, usluga } = props;
    const data = (usluga && usluga.uslugiKlientuUslugaNaMeropriyatii) ? usluga.uslugiKlientuUslugaNaMeropriyatii : undefined;// usluga.uslugiKlientuUslugaNaMeropriyatii.filter(i => i.yacheikaUsluga.prilozhenieID) : undefined;
    const gender = 2;
    const setMergedObject = (obj) => {
        onChange({
            genderID: gender,
            polzovatelStrokoi: obj.polzovatelStrokoi,
            polzovatelID: _.get(obj, "polzovatel.ID"),
            tovarVZakazeID: item.ID
        });
    };
    return (<div style={{ display: "flex", justifyContent: "flex-start" }}>
        <SelectPeople
            uuid={uuid()}
            auth={auth}
            gender={gender}
            item={item}
            index={index}
            data={data}
            prefix={(title) => <FemaleHeader title={title} />}
            value={value}
            onChangeSilent={onChangeSilent}
            onChange={(e) => setMergedObject(e)} />
    </div>);
};
const Single = (props) => {
    const auth = useAuth();
    const { item, index, value, onChange, onChangeSilent, usluga } = props;
    const data = (usluga && usluga.uslugiKlientuUslugaNaMeropriyatii) ? usluga.uslugiKlientuUslugaNaMeropriyatii : undefined;// usluga.uslugiKlientuUslugaNaMeropriyatii.filter(i => i.yacheikaUsluga.prilozhenieID) : undefined;
    const setMergedObject = (obj) => {
        onChange({
            polzovatelStrokoi: obj.polzovatelStrokoi,
            polzovatelID: _.get(obj, "polzovatel.ID"),
            tovarVZakazeID: item.ID
        });
    };
    return (<div style={{ display: "flex", justifyContent: "flex-start" }}>
        <SelectPeople
            uuid={uuid()}
            auth={auth}
            prefix={(title) => <SingleHeader title={title} />}
            item={item}
            index={index}
            data={data}
            value={value}
            onChangeSilent={onChangeSilent}
            onChange={(e) => setMergedObject(e)} />
    </div>);
};
const SingleByGender = (props) => {
    const { auth, item, index, value, onChange, onChangeSilent, usluga } = props;
    const data = (usluga && usluga.uslugiKlientuUslugaNaMeropriyatii) ? usluga.uslugiKlientuUslugaNaMeropriyatii : undefined;
    let genderID = value?.polzovatel?.genderID || value?.genderID;
    const setMergedObject = (obj) => {
        onChange({
            polzovatelStrokoi: obj.polzovatelStrokoi,
            polzovatelID: _.get(obj, "polzovatel.ID"),
            tovarVZakazeID: item.ID
        });
    };
    return (<div style={{ display: "flex", justifyContent: "flex-start" }}>
        <SelectPeople
            uuid={uuid()}
            auth={auth}
            prefix={(title) => (genderID == 1) ? <MaleHeader title={title} /> : (genderID == 2) ? <FemaleHeader title={title} /> : <Header icon="user-alt-3" title="" style={{ color: "cadetblue", fontSize: "13px", paddingRight: "4px" }} />}
            item={item}
            gender={genderID}
            index={index}
            data={data}
            value={value}
            onChangeSilent={onChangeSilent}
            onChange={(e) => setMergedObject(e)} />
    </div>);
};
const RenderCartItem = (props) => {
    const auth = useAuth();
    const { item, index, onInsideChange, deleteItem, zakaz, uslugi } = props;
    const usluga = uslugi.find(e => e.Usluga?.ID === item?.uslugaNaMeropriyatii?.ID)?.Usluga;
    const description = (<div>
        {(!!item.uslugaNaMeropriyatii && !!item.uslugaNaMeropriyatii.opisanie) && <div style={{ fontSize: "13px" }}>
            <pre style={{
                margin: "0",
                padding: "0",
                whiteSpace: "pre-wrap",
                fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans- serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'"
            }}>
                {item.uslugaNaMeropriyatii.opisanie}
            </pre>
        </div>}
    </div>);
    const newPolzovateliVZakazeTovarVZakaze = (zakaz, polzovateliVZakazeTovarVZakaze) => {
        return {
            ...zakaz, tovariVZakazeZakaz: zakaz.tovariVZakazeZakaz.map(e => {
                if (e.ID === item.ID) {
                    return {
                        ...e,
                        polzovateliVZakazeTovarVZakaze: polzovateliVZakazeTovarVZakaze(e)
                    }
                }
                return e;
            })
        }
    };
    const newTovarVZakaze = (zakaz, tovarVZakaze) => {
        return {
            ...zakaz, tovariVZakazeZakaz: zakaz.tovariVZakazeZakaz.map(e => {
                if (e.ID === tovarVZakaze.ID) {
                    return {
                        ...e,
                        ...tovarVZakaze
                    }
                }
                return e;
            })
        }
    };
    const onPolzovateliVZakazeTovarVZakaze = (p, old) => {
        POST(auth, "/api/zakaz/tovar/polzovatel/change", {
            delPolzovatel: old,
            newPolzovatel: p
        }, ({ data }) => {
            onInsideChange(newPolzovateliVZakazeTovarVZakaze(zakaz, (e) => {
                if (old) {
                    return [...((e.polzovateliVZakazeTovarVZakaze) ? e.polzovateliVZakazeTovarVZakaze.filter(f => f.ID !== old.ID) : []), data];
                } else {
                    return [...((e.polzovateliVZakazeTovarVZakaze) ? e.polzovateliVZakazeTovarVZakaze : []), data];
                }
            }), uslugi);
        }, errorCatch);
    };
    const onChangeSilent = (people) => {
        let z = newPolzovateliVZakazeTovarVZakaze(zakaz, (e) =>
            [...((e.polzovateliVZakazeTovarVZakaze) ? e.polzovateliVZakazeTovarVZakaze.map(p => {
                if (p.ID === people.ID) {
                    return people;
                }
                return p;
            }) : [])]
        );
        onInsideChange(z, uslugi);
    };
    const onChangeTovar = (tovar) => {
        let z = newTovarVZakaze(zakaz, tovar);
        onInsideChange(z, uslugi);
    };
    const getPeopleByGender = (array, genderID) => {
        if (!array) return;
        for (let i = 0; i < array.length; i++) {
            const element = array[i];
            if ((element.polzovatel && element.polzovatel.genderID === genderID) ||
                (element.genderID && element.genderID === genderID) ||
                (element.polzovatelStrokoi)) {
                return element;
            }
        }
        // if (array.length > defaultIndex) {
        //     return array[defaultIndex];
        // }
    };

    return (<>
        {/* <SwipeAction style={{ width: "100%" }} autoClose right={[{
            text: (<Icofont icon="close" />),
            onPress: () => deleteItem(),
            style: { backgroundColor: '#F4333C', color: 'white', minWidth: "20%" },
        }]}> */}
        <div style={{ display: "flex", justifyContent: "space-between", alignContent: "stretch" }}>
            <div>
                <div style={{ whiteSpace: "initial", fontSize: "14px" }}>
                    <div style={{ fontWeight: "500" }}>{item.uslugaNaMeropriyatii.nazvanie}</div>
                    <div style={{ fontWeight: "300" }}>{description}</div>
                </div>
                <div style={{ alignSelf: "flex-start", textAlign: "start" }}>
                    <div style={{ padding: "5px 0px" }}>
                        {(item.uslugaNaMeropriyatii.vidUslugiID === 1) &&
                            <Male auth={auth} item={item} index={index}
                                value={getPeopleByGender(item.polzovateliVZakazeTovarVZakaze, 1)}
                                onChangeSilent={onChangeSilent}
                                onChange={(v) => onPolzovateliVZakazeTovarVZakaze(v, getPeopleByGender(item.polzovateliVZakazeTovarVZakaze, 1, 0))}
                                usluga={usluga} />
                        }
                        {(item.uslugaNaMeropriyatii.vidUslugiID === 2) &&
                            <Female auth={auth} item={item} index={index}
                                value={getPeopleByGender(item.polzovateliVZakazeTovarVZakaze, 2)}
                                onChangeSilent={onChangeSilent}
                                onChange={(v) => onPolzovateliVZakazeTovarVZakaze(v, getPeopleByGender(item.polzovateliVZakazeTovarVZakaze, 2, 0))}
                                usluga={usluga} />
                        }
                        {(item.uslugaNaMeropriyatii.vidUslugiID === 3) &&
                            <div style={{ display: "flex", justifyContent: "flex-start" }}>
                                <div>
                                    {/* {JSXMap(item.polzovateliVZakazeTovarVZakaze, (e, idx) => {
                                        let genderID = e?.polzovatel?.genderID || e.genderID;
                                        return (<div key={idx} style={{ paddingBottom: "5px" }}>
                                            {genderID == 1 && <Male auth={auth} usluga={usluga} item={item} index={index}
                                                value={e}
                                                onChangeSilent={onChangeSilent}
                                                onChange={(v) => onPolzovateliVZakazeTovarVZakaze(v, e)} />}
                                            {genderID == 2 && <Female auth={auth} usluga={usluga} item={item} index={index}
                                                value={e}
                                                onChangeSilent={onChangeSilent}
                                                onChange={(v) => onPolzovateliVZakazeTovarVZakaze(v, e)} />}
                                            {(genderID != 1 && genderID != 2) && <Single auth={auth} item={item} index={index}
                                                value={e}
                                                onChangeSilent={onChangeSilent}
                                                onChange={(v) => onPolzovateliVZakazeTovarVZakaze(v, e)}
                                                usluga={usluga} />}
                                        </div>)
                                    })} */}
                                    <div style={{ paddingBottom: "5px" }}>
                                        <SingleByGender auth={auth} usluga={usluga} item={item} index={index}
                                            value={_.get(item, "polzovateliVZakazeTovarVZakaze[0]")}
                                            onChangeSilent={onChangeSilent}
                                            onChange={(v) => onPolzovateliVZakazeTovarVZakaze(v, _.get(item, "polzovateliVZakazeTovarVZakaze[0]"))} />
                                    </div>
                                    <div style={{ paddingBottom: "5px" }}>
                                        <SingleByGender auth={auth} usluga={usluga} item={item} index={index}
                                            value={_.get(item, "polzovateliVZakazeTovarVZakaze[1]")}
                                            onChangeSilent={onChangeSilent}
                                            onChange={(v) => onPolzovateliVZakazeTovarVZakaze(v, _.get(item, "polzovateliVZakazeTovarVZakaze[1]"))} />
                                    </div>
                                </div>
                            </div>}
                        {(item.uslugaNaMeropriyatii.vidUslugiID === 4) &&
                            <Single auth={auth} item={item} index={index}
                                value={_.get(item, "polzovateliVZakazeTovarVZakaze[0]")}
                                onChangeSilent={onChangeSilent}
                                onChange={(v) => onPolzovateliVZakazeTovarVZakaze(v, _.get(item, "polzovateliVZakazeTovarVZakaze[0]"))}
                                usluga={usluga} />
                        }
                    </div>
                </div>
                {(item?.uslugaNaMeropriyatii?.vklyuchitKommentarii == true) && <div>
                    <Action
                        auth={auth}
                        okText="Сохранить"
                        action={(values, unlock, close) => {
                            POST(auth, `/api/zakaz/tovar/kommentarii/add`, {
                                ...item,
                                ...values
                            }, ({ data }) => {
                                onChangeTovar({ ...item, kommentarii: data?.kommentarii })
                                close()
                            }, (err) => errorCatch(err, () => unlock()))
                        }}
                        object={item}
                        form={ModelMobile}
                        meta={[
                            {
                                label: "Комментарий покупателя",
                                name: "kommentarii",
                                type: "string",
                                size: "small"
                            }
                        ]}
                        mode={"func"}
                        trigger={(click) => (
                            <div className='bg bg-transparent pointer border-grey' style={{ fontSize: "12px", textAlign: "left", margin: "5px 0" }}
                                onClick={click}>
                                <div style={{ fontSize: "11px", color: "rgba(0,0,0,.65)", display: "flex", justifyContent: "space-between" }}>
                                    <div><i className="fa fa-comments-o"></i> Комментарий покупателя</div>
                                    <div><i className="fa fa-pencil-square-o"></i></div>
                                </div>
                                {/* <div>{item?.kommentarii}</div> */}
                                <div><Nl2Br text={item?.kommentarii} /></div>
                            </div>
                        )}
                    />
                </div>}
            </div>
            <div style={{ minWidth: "110px", maxWidth: "110px" }}>
                <div style={{ alignSelf: "flex-start", color: "darkblue", textAlign: "end", fontWeight: "500", fontSize: "15px" }}>
                    <div style={(item.tsena !== item.tsenaDoPromokoda) ? { textDecoration: "line-through" } : {}}>{(item.tsenaDoPromokoda).toLocaleString()} руб.</div>
                    {(item.tsena !== item.tsenaDoPromokoda) && <div style={{ color: "red" }}>{(item.tsena).toLocaleString()} руб.</div>}
                    <div style={{ textAlign: "end" }}>
                        <div style={{ display: "flex", justifyContent: "flex-end", paddingTop: "5px" }}>
                            <Button type="text" style={{ height: "30px", lineHeight: "22px", fontWeight: "600", padding: "4px 8px", fontSize: "12px" }}
                                onClick={deleteItem}>
                                <Icofont icon="ui-delete" />
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>)
};
const RenderSelectItem = (props) => {
    const { item } = props;
    const tarif = item.Tarifi[0];
    const description = (<div>
        {item.Usluga.opisanie && <div style={{ fontSize: "13px" }}>
            <pre style={{
                margin: "0",
                padding: "0",
                whiteSpace: "pre-wrap",
                fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans- serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'"
            }}>
                {item.Usluga.opisanie}
            </pre>
        </div>}
    </div>);
    return (<div style={{ display: "flex", justifyContent: "space-between", flexDirection: "row", flexWrap: "nowrap", alignContent: "stretch", width: "100%" }}>
        <div>
            <div style={{ whiteSpace: "initial", fontSize: "14px" }}>
                <div style={{ fontWeight: "500" }}>{item.Usluga.nazvanie}</div>
                <div style={{ fontWeight: "300" }}>{description}</div>
            </div>
            <div style={{ alignSelf: "flex-start", textAlign: "start" }}>
                <div style={{ padding: "5px 0px" }}>
                    {(item.Usluga.vidUslugiID === 1) && <MaleHeader />}
                    {(item.Usluga.vidUslugiID === 2) && <FemaleHeader />}
                    {(item.Usluga.vidUslugiID === 3) && <CoupleHeader />}
                    {(item.Usluga.vidUslugiID === 4) && <SingleHeader />}
                </div>
            </div>
        </div>
        <div style={{ minWidth: "105px", maxWidth: "105px" }}>
            <div style={{ alignSelf: "flex-start", color: "darkblue", textAlign: "end", padding: "0px 0px 0px 0px", fontWeight: "500", fontSize: "15px" }}>
                <div style={(tarif.PricePromo !== tarif.PriceTarif) ? { textDecoration: "line-through" } : {}}>{(tarif.PriceTarif).toLocaleString()} руб.</div>
                {(tarif.PricePromo !== tarif.PriceTarif) && <div style={{ color: "red" }}>{(tarif.PricePromo).toLocaleString()} руб.</div>}
            </div>
        </div>
    </div>)
};
const SelectUslugiForm = (props) => {
    const classes = useStyles();
    const auth = useAuth();
    const { form, object, submit, promo, data } = props;
    useEffect(() => {
        form.setFieldsValue({ collection: object });
    }, [object]);
    return (<div className='select-uslugi-form'>
        {promo && <div style={{ fontWeight: "400" }}>
            <span>ПРОМОКОД: </span>
            <span style={{ fontWeight: "600", color: "red" }}>{promo}</span>
        </div>}
        <Form
            form={form}
            onFinish={submit}
            // labelalign={"left"}
            layout={"vertical"}
            initialValues={{ collection: object }}
        >
            <Form.Item name="collection" className={classes.itemsListUsluga}>
                <Collection
                    //data={_.pullAllBy([...data], object, 'ID') || []}
                    getSelectedOnly={true}
                    data={data || []}
                    selection="checkbox"
                    auth={auth}
                    noPrint={true}
                    noPagination={true}
                    size="small"
                    mode="list"
                    listRenderItem={(item, index) => <RenderSelectItem uuid={uuid()} item={item} index={index} />}
                    collectionActions={() => []}
                    modelActions={() => []}
                />
            </Form.Item>
        </Form>
    </div>)
};
function Dimmy({ constant, value, onChange }) {
    useEffect(() => {
        onChange(constant || value);
    }, [constant, value]);
    return <></>;
}
const CameraForm = (props) => {
    const { auth, close, form, play, onChange, resetField } = props;
    const [allowScan, setAllowScan] = useState(false);
    useEffect(() => {
        setAllowScan(true)
        return () => {
            setAllowScan(false)
        };
    }, []);
    return (<div>
        <QR allowScan={allowScan} visible={allowScan} onChange={(qr) => {
            if (qr) {
                let r = encodeURIComponent(qr);

                GET(auth, `/api/user-by-idcard?qr=${r}`, ({ data }) => {
                    if (form && resetField) {
                        form.setFieldValue(resetField, data);
                    }
                    setAllowScan(false);
                    play();
                    if (onChange) {
                        onChange(data);
                    }

                    if (close) {
                        close();
                    }
                }, (err) => errorCatch(err, () => {
                    // play-error();
                }))
            }
        }} />
        <div style={{ fontStyle: "italic", textAlign: "center", color: "#888", fontSize: "15px", height: "100%", lineHeight: "1.5" }}>
            * для поиска пользователя отсканируйте QR-код
        </div>
    </div>)
};
const CameraUserInput = (props) => {
    const { auth, form, resetField, onChange } = props;
    const [play] = useSound(bubbleSfx);

    return (<Dialog
        auth={auth}
        content={({ close }) => (<CameraForm auth={auth} close={close} form={form} play={play} onChange={onChange} resetField={resetField} />)}
        titles={{
            header: (<div style={{ display: "flex", justifyContent: "center", padding: "10px 15px 0px 15px", fontSize: "16px" }}>
                Сканер QR-кода
            </div>)
        }}
        trigger={(click) => (<div className='bg bg-grey border-red pointer' style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", alignContent: "center" }}
            onClick={() => {
                click()
            }}
        ><Icofont icon="qr-code" style={{ fontSize: "50px" }} /></div>)}
        stack={[]}
        footer={({
            close }) => [{
                name: (<span>Закрыть</span>),
                callback: () => {
                    if (close) {
                        close();
                    }
                },
                options: {
                    type: "primary"
                }
            }]}
    />)
};

function SelectUserForm(props) {
    const auth = useAuth();
    const { form, data, object, user } = props;
    const [isString, setIsString] = useState(false);
    const [radioValue, setRadioValue] = useState(-1);

    // founded
    const founded = useSelector(state => state.home.founded);

    const zaregistrirovanniiPolzovatel = data.some(e => (e.yacheikaUsluga.zaregistrirovanniiPolzovatel === true || e.yacheikaUsluga.prilozhenieID > 0));
    const minifyPeople = (people) => {
        return {
            ID: people.ID,
            firstname: people.firstname,
            lastname: people.lastname,
            genderID: (people.gender) ? people.gender.ID : undefined
        }
    };
    const setObjectPeoole = (people) => {
        form.setFieldsValue({
            polzovatel: minifyPeople(people)
        });
    };
    useEffect(() => {
        if (object) {
            if (!object.polzovatel && object.polzovatelStrokoi) {
                setIsString(true);
                setRadioValue(0);
            } else if (object.polzovatel) {
                setIsString(false);
                if (user.ID === object.polzovatelID) {
                    setRadioValue(-1);
                    setObjectPeoole(user);
                } if (object.polzovatelID > 0 && !!founded.find(e => e.ID == object.polzovatelID)) {
                    var u = founded.find(e => e.ID == object.polzovatelID);
                    setRadioValue(object.polzovatelID);
                    setObjectPeoole(u);
                } else {
                    setRadioValue(0);
                    setObjectPeoole(object.polzovatel);
                }
            }
        }
    }, [object]);
    const objectPeopleSelection = (value) => {
        setRadioValue(+value);
        if (value === -1) {
            setObjectPeoole(user);
        }
        if (value > 0) {
            setObjectPeoole(founded.find(e => e.ID === value));
        }
    };
    const findObjectPeople = (value) => {
        if (value === -1) {
            return user;
        }
        if (value > 0) {
            return founded.find(e => e.ID === value);
        }
    };
    return (<div>
        <div style={{ padding: "10px 10px" }}>
            <Radio.Group>
                <Space direction='vertical'>
                    <Radio
                        onChange={() => objectPeopleSelection(-1)}
                        checked={radioValue === -1}>
                        Я участник ({user.firstname + " " + user.lastname})
                    </Radio>
                    {founded && founded.filter(e => e.ID !== user.ID).map(e => (
                        <Radio
                            key={e.ID}
                            onChange={() => objectPeopleSelection(e.ID)}
                            checked={radioValue === e.ID}>
                            {e.firstname + " " + e.lastname}
                        </Radio>
                    ))}
                    <Radio
                        onChange={() => objectPeopleSelection(0)}
                        checked={radioValue === 0}>
                        Другой человек
                    </Radio>
                </Space>
            </Radio.Group>
            {(radioValue === 0 && zaregistrirovanniiPolzovatel !== true) && <div style={{ paddingTop: "10px" }}>
                <Checkbox
                    style={{
                        '--font-size': "13px",
                        '--icon-size': "18px"
                    }}
                    checked={isString}
                    onChange={(e) => setIsString(e)}>Указать участника строкой</Checkbox>
            </div>}
        </div>
        <div className='people-selection' style={{ padding: "0px 10px" }}>
            <Form
                form={form}
                onFinish={props.submit}
                layout={"vertical"}
                initialValues={{ ...object, polzovatelStrokoi: (object && object.polzovatelStrokoi) ? object.polzovatelStrokoi : "" }}
            >
                {(radioValue > 0) && <>
                    <Form.Item label="" name="polzovatel">
                        <Dimmy constant={findObjectPeople(radioValue)} />
                    </Form.Item>
                </>}
                {(radioValue === -1) && <>
                    <Form.Item label="" name="polzovatel">
                        <Dimmy constant={minifyPeople(user)} />
                    </Form.Item>
                </>}
                {(radioValue === 0) && <>
                    {(isString && radioValue === 0) &&
                        <Form.Item
                            name="polzovatelStrokoi"
                            rules={[{ required: false, message: 'Пожалуйста, укажите ФИО!' }]}
                        >
                            <Input placeholder='Укажите ФИО участника'
                                style={{ '--font-size': "14px" }} />
                        </Form.Item>
                    }
                    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                        {!isString && <>
                            <Form.Item label="" name="otherPolzovatel" style={{ flex: "1 1 auto" }}>
                                <ActionPickerItem
                                    auth={auth}
                                    mode="input"
                                    item={{
                                        triggerStyle: {
                                            fontSize: "14px"
                                        },
                                        label: "Пользователь",
                                        // placeholder: "Нажмите тут для выбора пользователя",
                                        placeholder: (<span style={{
                                            color: "#446ffe",
                                            fontStyle: "unset",
                                            borderBottom: "1px solid #446ffe",
                                            borderBottomStyle: "dashed",
                                        }}>Нажмите тут для выбора пользователя</span>),
                                        display: (v) => {
                                            return <span style={{
                                                color: "#446ffe",
                                                fontStyle: "unset",
                                                borderBottom: "1px solid #446ffe",
                                                borderBottomStyle: "dashed",
                                            }}>{v.firstname + " " + v.lastname}</span>
                                        },
                                        modify: (values) => {
                                            return values.search;
                                        },
                                        steps: [
                                            {
                                                key: "search",
                                                name: "Шаг 1",
                                                action: (values, unlock, close) => {
                                                    POST(auth, "/api/find/finduserfilter", { ...values },
                                                        ({ data }) => {
                                                            close(data);
                                                        },
                                                        (err) => {
                                                            Toast.show({
                                                                icon: 'fail',
                                                                content: err.message || err.exception,
                                                            })
                                                            unlock();
                                                        });
                                                },
                                                form: SearchUser,
                                            },
                                            {
                                                key: "select",
                                                name: "Шаг 2",
                                                noAntForm: true,
                                                form: (props) => {
                                                    return (
                                                        <div style={{ padding: "0px 10px" }}>
                                                            <div>Подтвердите выбор пользователя:</div>
                                                            <div>ФИО: <span style={{ color: "#000" }}>{(props.data) ? props.data.search.firstname + " " + props.data.search.lastname : ""}</span></div>
                                                            <div>Email: <span style={{ color: "#000" }}>{(props.data) ? props.data.search.email : ""}</span></div>
                                                        </div>
                                                    )
                                                },
                                            }
                                        ]
                                    }}
                                />
                            </Form.Item>
                        </>}
                        {!isString && <>
                            <div style={{ fontSize: "12px" }}>
                                Или можно сканировать QR-код профиля пользователя
                            </div>
                            <Form.Item label="" name="otherPolzovatelQR" style={{ width: "50px", flex: "0 0 50px" }}>
                                <CameraUserInput auth={auth} form={form} resetField="otherPolzovatel" />
                            </Form.Item>
                        </>}
                    </div>
                </>}
            </Form>
        </div>
    </div>);
}
function SelectPartnerForm(props) {
    const auth = useAuth();
    const { form, data, object, user } = props;
    // const [isString, setIsString] = useState(false);
    const [radioValue, setRadioValue] = useState(-1);

    // founded
    const founded = useSelector(state => state.home.founded);

    const zaregistrirovanniiPolzovatel = data.some(e => (e.yacheikaUsluga.zaregistrirovanniiPolzovatel === true || e.yacheikaUsluga.prilozhenieID > 0));
    const minifyPeople = (people) => {
        return {
            ID: people.ID,
            firstname: people.firstname,
            lastname: people.lastname,
            genderID: (people.gender) ? people.gender.ID : undefined
        }
    };
    const setObjectPeoole = (people) => {
        form.setFieldsValue({
            polzovatel: minifyPeople(people)
        });
    };
    useEffect(() => {
        if (object) {
            if (object.polzovatel) {

                if (user.ID === object.polzovatelID) {
                    setRadioValue(-1);
                    setObjectPeoole(user);
                } if (object.polzovatelID > 0 && !!founded.find(e => e.ID == object.polzovatelID)) {
                    var u = founded.find(e => e.ID == object.polzovatelID);
                    setRadioValue(object.polzovatelID);
                    setObjectPeoole(u);
                } else {
                    setRadioValue(0);
                    setObjectPeoole(object.polzovatel);
                }
            }
        }
    }, [object]);
    const objectPeopleSelection = (value) => {
        setRadioValue(+value);
        if (value === -1) {
            setObjectPeoole(user);
        }
        if (value > 0) {
            setObjectPeoole(founded.find(e => e.ID === value));
        }
    };
    const findObjectPeople = (value) => {
        if (value === -1) {
            return user;
        }
        if (value > 0) {
            return founded.find(e => e.ID === value);
        }
    };
    return (<div>
        <div style={{ padding: "10px 10px" }}>
            <Radio.Group>
                <Space direction='vertical'>
                    <Radio
                        onChange={() => objectPeopleSelection(-1)}
                        checked={radioValue === -1}>
                        Я участник ({user.firstname + " " + user.lastname})
                    </Radio>
                    {founded && founded.filter(e => e.ID !== user.ID).map(e => (
                        <Radio
                            key={e.ID}
                            onChange={() => objectPeopleSelection(e.ID)}
                            checked={radioValue === e.ID}>
                            {e.firstname + " " + e.lastname}
                        </Radio>
                    ))}
                    <Radio
                        onChange={() => objectPeopleSelection(0)}
                        checked={radioValue === 0}>
                        Другой человек
                    </Radio>
                </Space>
            </Radio.Group>

        </div>
        <div className='people-selection' style={{ padding: "0px 10px" }}>
            <Form
                form={form}
                onFinish={props.submit}
                layout={"vertical"}
                initialValues={{ ...object, polzovatelStrokoi: (object && object.polzovatelStrokoi) ? object.polzovatelStrokoi : "" }}
            >
                {(radioValue > 0) && <>
                    <Form.Item label="" name="polzovatel">
                        <Dimmy constant={findObjectPeople(radioValue)} />
                    </Form.Item>
                </>}
                {(radioValue === -1) && <>
                    <Form.Item label="" name="polzovatel">
                        <Dimmy constant={minifyPeople(user)} />
                    </Form.Item>
                </>}
                {(radioValue === 0) && <>
                    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>

                        <Form.Item label="" name="otherPolzovatel" style={{ flex: "1 1 auto" }}>
                            <ActionPickerItem
                                auth={auth}
                                mode="input"
                                item={{
                                    triggerStyle: {
                                        fontSize: "14px"
                                    },
                                    label: "Пользователь",
                                    // placeholder: "Нажмите тут для выбора пользователя",
                                    placeholder: (<span style={{
                                        color: "#446ffe",
                                        fontStyle: "unset",
                                        borderBottom: "1px solid #446ffe",
                                        borderBottomStyle: "dashed",
                                    }}>Нажмите тут для выбора пользователя</span>),
                                    display: (v) => {
                                        return <span style={{
                                            color: "#446ffe",
                                            fontStyle: "unset",
                                            borderBottom: "1px solid #446ffe",
                                            borderBottomStyle: "dashed",
                                        }}>{v.firstname + " " + v.lastname}</span>
                                    },
                                    modify: (values) => {
                                        return values.search;
                                    },
                                    steps: [
                                        {
                                            key: "search",
                                            name: "Шаг 1",
                                            action: (values, unlock, close) => {
                                                POST(auth, "/api/find/finduserfilter", { ...values },
                                                    ({ data }) => {
                                                        close(data);
                                                    },
                                                    (err) => {
                                                        Toast.show({
                                                            icon: 'fail',
                                                            content: err.message || err.exception,
                                                        })
                                                        unlock();
                                                    });
                                            },
                                            form: SearchUser,
                                        },
                                        {
                                            key: "select",
                                            name: "Шаг 2",
                                            noAntForm: true,
                                            form: (props) => {
                                                return (
                                                    <div style={{ padding: "0px 10px" }}>
                                                        <div>Подтвердите выбор пользователя:</div>
                                                        <div>ФИО: <span style={{ color: "#000" }}>{(props.data) ? props.data.search.firstname + " " + props.data.search.lastname : ""}</span></div>
                                                        <div>Email: <span style={{ color: "#000" }}>{(props.data) ? props.data.search.email : ""}</span></div>
                                                    </div>
                                                )
                                            },
                                        }
                                    ]
                                }}
                            />
                        </Form.Item>
                        <div style={{ fontSize: "12px" }}>
                            Или можно сканировать QR-код профиля пользователя
                        </div>
                        <Form.Item label="" name="otherPolzovatelQR" style={{ width: "50px", flex: "0 0 50px" }}>
                            <CameraUserInput auth={auth} form={form} resetField="otherPolzovatel" />
                        </Form.Item>

                    </div>
                </>}
            </Form>
        </div>
    </div>);
}
function CollectionList(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const auth = useAuth();
    const { value, onInsideChange, zakaz, uslugi, promo } = props;
    const user = useSelector(state => state.home.user);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        auth.fetch('/api/iam').then(res => {
            if (res && res.data) {
                dispatch({ type: 'USER', payload: res.data })
            }
        });
    }, []);

    const founded = useSelector(state => state.home.founded);
    useEffect(() => {
        let userList = [];
        if (zakaz && zakaz.tovariVZakazeZakaz && zakaz.tovariVZakazeZakaz.length) {
            for (let i = 0; i < zakaz.tovariVZakazeZakaz.length; i++) {
                let tovar = zakaz.tovariVZakazeZakaz[i];
                if (tovar && tovar.polzovateliVZakazeTovarVZakaze && tovar.polzovateliVZakazeTovarVZakaze.length) {
                    for (let j = 0; j < tovar.polzovateliVZakazeTovarVZakaze.length; j++) {
                        let user = tovar.polzovateliVZakazeTovarVZakaze[j];
                        if (user && user.polzovatel) {
                            userList.push(user.polzovatel);
                        }
                        if (user && user?.okazannieUslugiPolzovatelyamUchastik?.length) {
                            for (let k = 0; k < user?.okazannieUslugiPolzovatelyamUchastik.length; k++) {
                                if (user?.okazannieUslugiPolzovatelyamUchastik[k].partner) {
                                    userList.push(user?.okazannieUslugiPolzovatelyamUchastik[k].partner);
                                }
                            }
                        }
                    }
                }
            }
        }
        let f = _.unionBy(userList, founded || [], 'ID').filter(e => e.ID !== user.ID)
        dispatch({ type: 'FOUNDED', payload: f });
    }, [zakaz]);

    const deleteItem = (item) => {
        Modal.confirm({
            title: "Удаление",
            content: 'Удалить услугу из корзины?',
            confirmText: "Да",
            cancelText: "Нет",
            onConfirm: () => {
                setLoading(true);
                POST(auth, `/api/zakaz/tovar/delete?promo=${promo}`, item,
                    (res) => {
                        onInsideChange(res.data /*zakaz*/, res.uslugiPrice);
                        setLoading(false);
                    }, (err) => errorCatch(err, () => setLoading(false)));
            },
        })
    };
    const addItem = (values, unlock, close) => {
        setLoading(true);
        let add = values?.collection?.filter(e => !!e && e.Usluga).map(e => e.Usluga);
        if (add && add.length) {
            POST(auth, `/api/zakaz/tovar/add?promo=${promo}`, add,
                (res) => {
                    onInsideChange(res.data /*zakaz*/, res.uslugiPrice);
                    setLoading(false);
                    close();
                }, (err) => errorCatch(err, () => setLoading(false)));
        } else {
            setLoading(false);
            close();
        }
    };
    return (
        <div>
            <div className='order-add-list' style={{ padding: "15px 0px" }}>
                <Action
                    // modal={{ title: "Выбор услуг", width: "600px" }}
                    auth={auth}
                    data={uslugi}
                    object={value}
                    promo={promo}
                    title={"ДОБАВИТЬ УСЛУГИ"}
                    titles={{
                        header: "Выбор услуг",
                    }}
                    triggerOptions={{ className: classes.appendButton }}
                    triggerStyle={{ textAlign: "center" }}
                    okText="Выбрать"
                    form={SelectUslugiForm}
                    action={addItem}
                    mode="func"
                    trigger={(click) => (
                        <Button onClick={click} block style={{
                            boxShadow: "0px 1px 3px 0px rgba(141,141,141,0.74)",
                            fontWeight: 500,
                            textAlign: "center",
                            backgroundColor: "#f1f1f1",
                            borderRadius: "5px",
                            width: "190px"
                        }}>
                            ДОБАВИТЬ УСЛУГИ
                        </Button>
                    )}
                />
            </div>
            {(user && (user.firstname || user.lastname)) && <>
                {!!loading && <div style={{
                    width: "100%",
                    minHeight: "150px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    <SpinLoading style={{ '--size': '32px' }} />
                </div>}
                <div className='order-list'>
                    {!loading && <List className={classes.itemsOrderUsluga} style={{ "--padding-left": "0px", "--padding-right": "0px" }}>
                        {!!value && value.map((item, index) => (
                            <List.Item key={index} className={classes.listItem} >
                                <RenderCartItem
                                    auth={auth}
                                    uuid={uuid()}
                                    item={item}
                                    index={index}
                                    zakaz={zakaz}
                                    uslugi={uslugi}
                                    promo={promo}
                                    deleteItem={() => deleteItem(item)}
                                    onInsideChange={(zakaz, uslugi) => onInsideChange(zakaz, uslugi)} />
                            </List.Item>
                        ))}
                    </List>}
                </div>
            </>}
            <div style={{ display: "flex", justifyContent: "space-between", fontWeight: "500", fontSize: "16px", padding: "10px 0px" }}>
                <div>
                    ИТОГО:
                </div>
                <div>
                    {_.sumBy(value, (e) => e.tsena).toLocaleString()} руб.
                </div>
            </div>
        </div>
    );
}
export function DatiVozvratov(props) {
    const { event } = props;
    const auth = useAuth()
    const [data, setData] = useState(undefined);
    const [object, setObject] = useState(undefined);

    useEffect(() => {
        if (event) {
            GET(auth, `/papi/fed/meropriyatiya/get/${event}`,
                ({ data }) => {
                    if (data && data.length) {
                        setObject(data[0]);
                    }
                }, errorCatch);
            GET(auth, `/papi/fed/dativozvratov/bymeropriyatie/${event}`,
                ({ data }) => {
                    if (data && data.length) {
                        setData(data);
                    }
                }, errorCatch);
        }
    }, [event]);

    const declOfNum = (number, words) => {
        return words[(number % 100 > 4 && number % 100 < 20) ? 2 : [2, 0, 1, 1, 1, 2][(number % 10 < 5) ? Math.abs(number) % 10 : 5]];
    }
    const nl2br = (str, is_xhtml) => {
        if (typeof str === 'undefined' || str === null) {
            return '';
        }
        var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
        let s = (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
        return s.replace(/(http[^\s|^\<]*)/g, "<a href='$1' target='_blank' rel='noopener noreferrer' >$1</a>")
    }
    const url2a = (str) => {
        if (typeof str === 'undefined' || str === null) {
            return '';
        }
        return str.replace(/(http[^\s|^\<]*)/g, "<a href='$1' target='_blank' rel='noopener noreferrer' >$1</a>")
    }
    return (<>
        <div>
            {(object && object.shapkaUsloviiVozvrata) && <div style={{ paddingBottom: "10px" }}>
                <pre style={{
                    margin: "0",
                    padding: "0",
                    whiteSpace: "pre-wrap",
                    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans- serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'"
                }}>
                    {parse(url2a(object.shapkaUsloviiVozvrata))}
                </pre>
            </div>}
            {(data && data.length > 0) && <div style={{ paddingBottom: "10px" }}>
                <div>Взимается сервисный сбор, который составляет:</div>
                {JSXMap(data, (e, eidx) => (
                    <div key={eidx} style={{ paddingBottom: "5px" }}>
                        <div style={{ fontWeight: "500" }}> - при возврате до {dayjs(e.dataVremya).format("DD.MM.YYYY (HH:mm)")} - {100 - e.protsent}%{(eidx != (data.length - 1)) ? "," : ""}</div>
                    </div>
                ))}
            </div>}
            {(object && object.podvalUsloviiVozvrata) && <div style={{ paddingBottom: "10px" }}>
                <pre style={{
                    margin: "0",
                    padding: "0",
                    whiteSpace: "pre-wrap",
                    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans- serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'"
                }}>
                    {parse(url2a(object.podvalUsloviiVozvrata))}
                </pre>
            </div>}
        </div>
    </>)
}

export default function PaymentForm(props) {
    const classes = useStyles();
    const auth = useAuth();
    const { form, steps, idx } = props;
    const [zakaz, setZakaz] = useState({});
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        form.resetFields();
        request();
    }, []);

    const [uslugi, setUslugi] = useState([]);
    const [promo, setPromo] = useState(""); //Вечеринка21
    const request = () => {
        setLoading(true);
        GET(auth, `/api/usluginameropriyatii/nowbymeropriyatieidandpromo/${steps[idx].event.ID}?promo=${promo}`,
            (res) => {
                res.zakaz.promokod = res.zakaz?.promokod || undefined;
                setZakaz(res.zakaz);
                form.resetFields();
                form.setFieldsValue(res.zakaz);
                setUslugi(res.data || []);
                setPromo(res.zakaz?.promokod);
                setLoading(false);
            }, (err) => errorCatch(err, () => setLoading(false)));
    };
    const updateFromInside = (zakaz, uslugi) => {
        setZakaz(zakaz);
        form.resetFields();
        form.setFieldsValue(zakaz);
        setUslugi(uslugi);
    };
    const validator = (func, message) => ({
        validator: (_, value) => {
            if (func(value)) {
                return Promise.resolve();
            }
            return Promise.reject(new Error(message))
        }
    });
    const isSetUser = (value) => {
        if (!value) return false;
        for (let i = 0; i < value.length; i++) {
            const item = value[i];
            if (!item.polzovateliVZakazeTovarVZakaze || item.polzovateliVZakazeTovarVZakaze.length <= 0) {
                return false;
            }
            if (item.uslugaNaMeropriyatii.vidUslugiID === 3 && item.polzovateliVZakazeTovarVZakaze.length < 2) {
                return false;
            }
            for (let id = 0; id < item.polzovateliVZakazeTovarVZakaze.length; id++) {
                const people = item.polzovateliVZakazeTovarVZakaze[id];
                if (!people) {
                    return false;
                }
                if (!people.polzovatelStrokoi && !people.polzovatel) {
                    return false;
                }
            }
        }
        return true;
    };
    const isSetCategory = (value) => {
        if (!value) return false;
        for (let i = 0; i < value.length; i++) {
            const item = value[i];
            if (item.polzovateliVZakazeTovarVZakaze) {
                for (let id = 0; id < item.polzovateliVZakazeTovarVZakaze.length; id++) {
                    const people = item.polzovateliVZakazeTovarVZakaze[id];
                    if (people) {
                        for (let k = 0; k < people.okazannieUslugiPolzovatelyamUchastik.length; k++) {
                            const y = people.okazannieUslugiPolzovatelyamUchastik[k];
                            if (y.uslugaKlientu.yacheikaUsluga.prilozhenieID) {
                                if (!y.kategoriya) {
                                    return false;
                                }
                            }
                        }
                    }
                }
            }
        }
        return true;
    };
    const isSetPartners = (value) => {
        if (!value) return false;
        for (let i = 0; i < value.length; i++) {
            const item = value[i];
            if (item.polzovateliVZakazeTovarVZakaze) {
                for (let id = 0; id < item.polzovateliVZakazeTovarVZakaze.length; id++) {
                    const people = item.polzovateliVZakazeTovarVZakaze[id];
                    if (people) {
                        for (let k = 0; k < people.okazannieUslugiPolzovatelyamUchastik.length; k++) {
                            const y = people.okazannieUslugiPolzovatelyamUchastik[k];
                            if (y.uslugaKlientu.yacheikaUsluga.prilozhenieID) {
                                if ((y.tipTDID === 1 || y.tipTDID === 2) && !y.partner) {
                                    return false;
                                }
                            }
                        }
                    }
                }
            }
        }
        return true;
    };
    const keyPress = () => {
        // if (e.key === 'Enter') {
        request();
        // }
    };
    return (
        <>
            {!!loading && <div style={{
                width: "100%",
                minHeight: "150px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }}>
                <SpinLoading style={{ '--size': '32px' }} />
            </div>}
            {!loading && <div className='order-form'>
                <Form
                    form={form}
                    onFinish={props.submit}
                    layout={"vertical"}
                    onValuesChange={(changedValues, allValues) => {
                        setPromo(allValues.promokod);
                    }}
                >
                    <Form.Item
                        label=""
                        name="tovariVZakazeZakaz"
                        rules={[
                            { type: "array", required: true, message: 'Пожалуйста, выберите улсуги!' },
                            validator(isSetUser, 'Пожалуйста, укажите участников!'),
                            validator(isSetCategory, 'Пожалуйста, укажите категории!'),
                            validator(isSetPartners, 'Пожалуйста, укажите партнеров!'),
                        ]}
                    >
                        <CollectionList zakaz={zakaz} auth={auth} uslugi={uslugi} promo={zakaz.promokod} onInsideChange={updateFromInside} />
                    </Form.Item>
                    <div style={{ display: "flex", justifyContent: "end" }}>
                        <Form.Item
                            className={classes.promo}
                            style={{ width: "290px" }}
                            // label="Промокод"

                            name="promokod"
                            extra={
                                <Button key="1" onClick={request} size='small' style={{ marginBottom: "6px", backgroundColor: "#f1f1f1" }}>
                                    {/* <Icofont icon="check" /> */}
                                    ПРИМЕНИТЬ
                                </Button>
                            }
                        >
                            <Input placeholder="Промокод" clearable onEnterPress={keyPress} />
                        </Form.Item>
                    </div>
                    <div style={{
                        fontSize: "12px",
                        paddingTop: "30px"
                    }}>
                        <DatiVozvratov event={zakaz?.meropriyatieID} />
                    </div>
                    <Form.Item
                        name="agreement"
                        valuePropName="checked"
                        rules={[validator((value) => !!value, 'Пожалуйста, подтвердите согласие с правилами!')]}
                    >
                        <Checkbox style={{ marginLeft: "0px", fontSize: "12px" }}>
                            {(!!zakaz?.nastroikaEkvairingaID) && <Agreement nastroikaEkvairingaID={zakaz?.nastroikaEkvairingaID} />}
                        </Checkbox>
                    </Form.Item>
                </Form>
            </div>}
        </>
    );
}